import { render, staticRenderFns } from "./ModalRemuneracaoAddGrupoRepasse.vue?vue&type=template&id=65a460fc&scoped=true"
import script from "./ModalRemuneracaoAddGrupoRepasse.vue?vue&type=script&lang=ts"
export * from "./ModalRemuneracaoAddGrupoRepasse.vue?vue&type=script&lang=ts"
import style0 from "./ModalRemuneracaoAddGrupoRepasse.vue?vue&type=style&index=0&id=65a460fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a460fc",
  null
  
)

export default component.exports